import { Route, Routes } from 'react-router-dom';

import { RecordPaymentPage } from './pages/RecordPayment/RecordPaymentPage';
import { RecordPaymentSuccessPage } from './pages/RecordPaymentSuccessPage';
import { PaymentSelectTaxReturnPage } from './pages/SelectTaxReturn/PaymentSelectTaxReturnPage';
import { ViewPaymentPage } from './pages/ViewPayment/ViewPaymentPage';
import { ViewPaymentsPage } from './pages/ViewPayments/ViewPaymentsPage';

export const PaymentRouting = () => {
  return (
    <>
      <Routes>
        <Route path="declaration/tax-return" element={<PaymentSelectTaxReturnPage />} />
        <Route path="declaration/view" element={<ViewPaymentsPage />} />
        <Route path="declaration/record" element={<RecordPaymentPage />} />
        <Route path="declaration/record/success/:id" element={<RecordPaymentSuccessPage />} />
        <Route path="declaration/view/:id" element={<ViewPaymentPage />} />
      </Routes>
    </>
  );
};
